export enum InboxAssignedType {
  ALL = 'All',
  FOR_YOU = 'For you',
  ASSIGNED = 'Assigned',
  UNASSIGNED = 'Unassigned',
}
